import { DialogComponent } from '@theme/dialog';

class ProductInfoDrawer extends DialogComponent {
  /** @returns {HTMLElement | undefined} */
  get #triggers() {
    const el = this.refs.triggers;
    return el instanceof HTMLElement ? el : undefined;
  }

  /** @returns {HTMLElement | undefined} */
  get #dialog() {
    const el = this.refs.dialog;
    return el instanceof HTMLElement ? el : undefined;
  }

  connectedCallback() {
    super.connectedCallback();
    this.#triggers?.addEventListener('click', this.#handleTriggerClick);
    this.addEventListener('shopify:block:select', this.#handleBlockSelect);
    this.addEventListener('shopify:block:deselect', this.#handleBlockDeselect);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.#triggers?.removeEventListener('click', this.#handleTriggerClick);
    this.removeEventListener('shopify:block:select', this.#handleBlockSelect);
    this.removeEventListener('shopify:block:deselect', this.#handleBlockDeselect);
  }

  /** @param {Event} event */
  #handleTriggerClick = (event) => {
    const button = /** @type {HTMLElement | null} */ (
      event.target instanceof HTMLElement ? event.target.closest('[data-target]') : null
    );
    if (!button) return;

    const targetId = button.dataset.target;
    this.#preOpenAccordion(targetId);
    this.showDialog();
  };

  #handleBlockDeselect = () => {
    this.closeDialog();
  };

  /** @param {CustomEvent} event */
  #handleBlockSelect = (event) => {
    const blockId = event.detail?.blockId;
    if (!blockId) return;

    this.#preOpenAccordion(blockId);
    this.showDialog();
  };

  /** @param {string | undefined} targetId */
  #preOpenAccordion(targetId) {
    const dialog = this.#dialog;
    if (!dialog) return;
    const accordions = dialog.querySelectorAll('.product-info-drawer__accordion');
    for (const accordion of accordions) {
      if (accordion instanceof HTMLDetailsElement) {
        accordion.open = accordion.dataset.id === targetId;
      }
    }
  }

  openDrawer() {
    this.showDialog();
  }

  closeDrawer() {
    this.closeDialog();
  }
}

if (!customElements.get('product-info-drawer')) {
  customElements.define('product-info-drawer', ProductInfoDrawer);
}
